/**
 * Shared self-fetching widget plumbing: implement fetchResource() and applyResult(res).
 * Widgets driven by the dashboard filters also use dashboardFilters.mixin.
 */
export default {
  props: {
    reloadToken: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: true,
      error: false,
      fetchToken: 0
    };
  },
  watch: {
    reloadToken() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      // Only the newest fetch may write state, so a slow response can't
      // overwrite a newer one.
      const token = ++this.fetchToken;
      this.loading = true;
      this.error = false;
      try {
        const res = await this.fetchResource();
        if (token !== this.fetchToken) return;
        this.applyResult(res);
      } catch (e) {
        if (token === this.fetchToken) this.error = true;
      } finally {
        if (token === this.fetchToken) this.loading = false;
      }
    }
  }
};
